module.exports = __webpack_public_path__ + "img/94850.ac988cf8.svg";